import React from 'react';

// Line icons drawn on a 24-unit grid in the current text colour, so they take
// the sidebar's active and muted colours without any per-icon styling.
const Svg: React.FC<React.PropsWithChildren<{ className?: string }>> = ({ className, children }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export const ShieldAlertIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Svg className={className}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M12 8v4" />
    <path d="M12 16h.01" />
  </Svg>
);

export const ScatterIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Svg className={className}>
    <path d="M3 3v16a2 2 0 0 0 2 2h16" />
    <circle cx="8.5" cy="14.5" r="1.25" />
    <circle cx="12.5" cy="8.5" r="1.25" />
    <circle cx="17" cy="12" r="1.25" />
    <circle cx="10" cy="5.5" r="1.25" />
    <circle cx="17.5" cy="6" r="1.25" />
  </Svg>
);

export const SunIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Svg className={className}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2" />
    <path d="M12 20v2" />
    <path d="m4.93 4.93 1.41 1.41" />
    <path d="m17.66 17.66 1.41 1.41" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="m6.34 17.66-1.41 1.41" />
    <path d="m19.07 4.93-1.41 1.41" />
  </Svg>
);

export const MoonIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Svg className={className}>
    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
  </Svg>
);

export const LogoutIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Svg className={className}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" x2="9" y1="12" y2="12" />
  </Svg>
);

export const CloseIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Svg className={className}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </Svg>
);
